import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e26853e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "mt-3 mx-3 text-10 md:text-11 lg:text-12" }

import { MaterialAndColorVariant } from '@/types/productServerApi';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';
import useProductDetailData from '@/shared/product/details/useProductDetailData';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultMaterialVariant',
  props: {
    variant: null
  },
  setup(__props: any) {




const { getMaterialImageUrl, clearActiveCustomizerOverlay } = useCustomizer();
const { variantId } = useProductDetailData();
const { updateSku } = useProductDetailPage();

const getIsSelectedVariant = (sku: string) => {
    return sku === variantId.value;
};

const selectVariant = (sku) => {
    clearActiveCustomizerOverlay(true);
    updateSku(sku);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: "cursor-pointer",
    title: __props.variant.color,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (selectVariant(__props.variant.sku)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-100 h-75 relative overflow-hidden border-2 border-white", { selected: getIsSelectedVariant(__props.variant.sku) }]),
      style: _normalizeStyle({ 'background-color': __props.variant?.hexColor ?? '' })
    }, [
      _createElementVNode("img", {
        width: "200",
        height: "160",
        src: _unref(getMaterialImageUrl)(__props.variant.materialImage),
        alt: __props.variant.color,
        loading: "lazy",
        class: "min-w-200 min-h-160 xy-center"
      }, null, 8, _hoisted_2)
    ], 6),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.variant.color), 1)
  ], 8, _hoisted_1))
}
}

})